export const codeMsg = {
  '2-0002-0002': '系统异常(错误码:2-0002-0002)，请联系管理员！', // 找不到应用
  '2-0001-0044': '系统异常(错误码:2-0001-0044)，请联系管理员！', // 获取菜单及操作异常
  '2-0002-0001': '系统异常(错误码:2-0002-0001)，请联系管理员！', // 登录错误
  '1-0001-0500': '系统异常(错误码:1-0001-0500)，请联系管理员！', // 系统异常
  '2-0002-0037': '账号或密码错误，请重新输入！',
  '1001': '登录凭证已失效，请重新登录！',
};
